// extracted by mini-css-extract-plugin
module.exports = {"details":"DetailsBlock_details__E_LM_","text":"DetailsBlock_text__j5pGX","label":"DetailsBlock_label__xiJv6"};